import { render } from "./history-materials.vue?vue&type=template&id=c590e116&ts=true"
import script from "./history-materials.vue?vue&type=script&lang=ts"
export * from "./history-materials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__